import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import format from 'date-fns/format';
import formatDistance from 'date-fns/formatDistance';

import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import TableRow from '@mui/material/TableRow';
import TableCell from 'components/TableCell';

import { locale } from 'const';
import { DashboardFlightsTableRow_flight$key } from '__generated__/DashboardFlightsTableRow_flight.graphql';

type Props = {
  flight: DashboardFlightsTableRow_flight$key;
};

const DashboardFlightsTableRow: FC<Props> = props => {
  const {
    id,
    shortName,
    departureDate,
    createdAt,
    updatedAt,
    lastSuccessfulUpdate,
  } = useFragment(
    graphql`
      fragment DashboardFlightsTableRow_flight on Flight {
        id
        shortName
        departureDate
        createdAt
        updatedAt

        lastSuccessfulUpdate {
          createdAt
        }
      }
    `,
    props.flight
  );

  const successfullUpdate = lastSuccessfulUpdate
    ? lastSuccessfulUpdate.createdAt
    : createdAt;

  return (
    <TableRow>
      <TableCell>
        <Link href={`/flights/${id}`}>
          {format(new Date(departureDate), 'yyyy-MM-dd')}
        </Link>{' '}
        <Link href={`/flights/${id}`}>{shortName}</Link>
      </TableCell>

      <TableCell center>
        <Tooltip title={`Tikrinta ${updatedAt}`}>
          <span>
            {successfullUpdate
              ? formatDistance(new Date(successfullUpdate), new Date(), {
                  locale,
                  addSuffix: true,
                })
              : '-'}
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default DashboardFlightsTableRow;
